{
  "global.siteDescription": "用 30 秒認真介紹自己，讓別人快速認識你。",
  "global.languageSwitch": "切換語言",
  "global.languageCurrent": "目前語言：{locale}",
  "global.language.zh-CN": "中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "關閉",
  "common.cancel": "取消",
  "common.save": "儲存",
  "common.delete": "刪除",
  "common.edit": "編輯",
  "common.manage": "管理",
  "common.login": "登入",
  "common.logout": "退出",
  "common.loggingOut": "退出中",
  "common.logoutRetry": "重試退出",
  "common.preview": "預覽",
  "common.email": "信箱",
  "common.inviteCode": "邀請碼",
  "common.loading": "載入中",
  "editor.publish.processing": "仍在處理中",
  "common.localDraft": "本機草稿",
  "common.publicBeta": "公開測試中",
  "common.serviceStatus": "運作狀態",
  "common.optional": "可選",
  "common.page": "頁面",
  "common.reason": "原因",
  "common.description": "補充說明",
  "common.submit": "提交",
  "nav.login": "登入",
  "nav.draftFirst": "先寫草稿",
  "home.action.create": "建立我的介紹",
  "home.action.continue": "繼續寫",
  "home.action.manage": "管理介紹",
  "home.action.agent": "Agent 代筆",
  "home.meta.title": "30s.to — 30 秒，讓別人認識你。",
  "home.meta.description": "一人前行，更需要讓別人了解自己。30 秒，讓別人認識你。你是誰、在做什麼、做過什麼、能提供什麼資源。讓別人找到感興趣的地方，建立連結。",
  "home.title": "30 秒，\n讓別人認識你。",
  "home.freeNote": "建立、發佈、分享，永久免費。",
  "home.kicker": "一人前行，更需要讓別人了解自己",
  "home.value.copy": "你是誰、在做什麼、做過什麼、能提供什麼資源。讓別人找到感興趣的地方，建立連結。",
  "home.features.label": "產品特色",
  "home.features.time.tab": "30 秒讀完",
  "home.why.copy": "只寫最重要的。介紹越長，越少人讀完。30 秒，剛剛好。",
  "home.principle.expression.title": "自由表達",
  "home.principle.expression.copy": "經歷、作品、想法與資源，按自己的方式組織。寫下你想讓別人了解的自己。",
  "home.principle.link.title": "專屬 30s.to 連結",
  "home.principle.link.copy": "30s.to/@you，簡短、好記，也直白：30 秒，認識你。",
  "home.principle.theme.title": "豐富主題表達自己",
  "home.principle.theme.copy": "清爽、復古，或大膽鮮明。選一個像你的主題，讓別人從第一眼就感受到你的風格。",
  "home.footer.tagline": "少寫一點，重要的才會被看見。",
  "home.footer.navigation": "頁尾導航",
  "home.demo.linkNotice": "這是一個範例連結。創建你的 30 秒介紹後，就可以換成自己的。",
  "home.demo.profile.name": "林夏 / Lin Xia",
  "home.demo.profile.identity": "把複雜問題做成簡單產品的獨立設計師",
  "home.demo.profile.tag.product": "產品設計",
  "home.demo.profile.tag.indie": "獨立產品",
  "home.demo.profile.tag.ai": "AI 工具",
  "home.demo.profile.body": "## 最近\n我正在做訪談整理工具 Briefly，希望獨立設計師少花時間搬運筆記，多一點時間理解人。做產品前，我習慣先陪使用者走一遍真實流程。\n\n## 我的經歷\n2020—2023 年在協作軟體團隊做產品設計，負責編輯器與新使用者引導，和工程師一起把複雜操作拆成可完成的小步驟。\n\n2024 年起獨立工作，為早期團隊做使用者研究與互動設計，也持續打磨自己的小產品。\n\n## 我的專案\n- [Relay](https://example.com/projects/relay)：我負責設計的團隊決策記錄工具，把結論、理由與負責人放在一起，方便新加入的人理解背景。\n- [Briefly](https://example.com/projects/briefly)：正在小範圍試用的訪談筆記工具，把零散記錄整理成可追溯的主題，保留原話，方便設計師核對判斷。\n\n## 可以找我\n如果你有使用者回饋，卻不知道先改什麼，可以找我一起梳理問題、做可測試的原型。我也願意分享訪談提綱與研究記錄範本，適合剛開始接觸使用者研究的小團隊。\n\n## 一起聊聊\n想認識認真做小產品的人，聊聊第一次使用者訪談、產品取捨與獨立工作。週末常逛街角小店——有時，一張手寫價目表比產品說明更值得琢磨。",
  "home.demo.profile.link.website": "作品",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "約個時間",
  "handleStart.kicker": "公開網址",
  "handleStart.title": "選擇你的 30s.to 網址",
  "handleStart.copy": "先選一個容易記住的網址，再寫 30 秒介紹。已有草稿內容會繼續保留。",
  "handleStart.label": "你的網址",
  "handleStart.help.empty": "4-24 位小寫英文字母。現在只是儲存草稿，發佈時確認可用。",
  "handleStart.help.ok": "格式可用，發佈時會再次確認可用。",
  "handleStart.submit": "繼續寫介紹",
  "handleAvailability.checking": "正在檢查這個網址…",
  "handleAvailability.available": "目前可用，發布成功後正式歸你使用。",
  "handleAvailability.owned": "這是你目前擁有的地址。",
  "handleAvailability.assigned": "這是分配給你的地址，發布成功後生效。",
  "handleAvailability.failed": "暫時無法確認網址狀態，請重新檢查。",
  "handleAvailability.rateLimited": "檢查過於頻繁，請在 {minutes} 分鐘後再試。",
  "handleAvailability.retry": "重新檢查",
  "handleAvailability.suggestions": "也可以試試",
  "handleAvailability.cooldown": "公開網址仍在 30 天更換等待期內，可在 {date} 後再次更換；你也可以恢復為目前已發布的網址。",
  "editor.shell.loading": "載入建立流程",
  "editor.shell.workspace": "30 秒介紹工作區",
  "editor.shell.canvas": "30 秒介紹寫作台",
  "editor.command.aria": "編輯命令列",
  "editor.command.publish": "發布",
  "editor.command.publishUpdate": "發布修改",
  "editor.command.publishSettings": "發佈設定",
  "editor.command.dashboard": "管理頁",
  "editor.publish.success": "已發布",
  "editor.publish.successAfterLogin": "已登入並發布",
  "editor.publish.publishing": "正在發布…",
  "editor.publish.publishingDetail": "正在建立你的公開頁，請稍候。",
  "editor.publish.successDetail": "公開頁已更新，可以開啟查看。",
  "editor.publish.viewPublic": "查看公開頁",
  "editor.publish.cacheFailed": "但公開頁快取寫入失敗。",
  "editor.command.login": "登入",
  "editor.handle.editTitle": "修改公開地址",
  "editor.handle.claimAfterPublish": "發布後歸你使用",
  "editor.handle.claimAfterPublishTitle": "發布後該地址歸你使用",
  "editor.status.signedIn": "已登入",
  "editor.status.account": "帳號：{email}",
  "editor.status.localTitle": "本機草稿",
  "editor.status.localCopy": "目前草稿只保存在這台設備。登入後會同步到雲端。",
  "editor.status.location": "儲存位置",
  "editor.status.state": "保存狀態",
  "editor.status.emailLogin": "信箱登入",
  "editor.autosave.savingShort": "儲存中",
  "editor.autosave.savedCloudShort": "雲端已儲存",
  "editor.autosave.savedLocalShort": "已儲存至本機",
  "editor.autosave.failedShort": "保存失敗",
  "editor.autosave.signedInShort": "已登入",
  "editor.autosave.cloud": "雲端",
  "editor.autosave.retry": "需要重試",
  "editor.autosave.device": "目前設備",
  "editor.autosave.saving": "正在自動儲存...",
  "editor.autosave.savedLocal": "已自動儲存至本機",
  "editor.autosave.savedCloud": "已自動儲存到雲端",
  "editor.autosave.authExpired": "登入已失效，已儲存至本地",
  "editor.autosave.cloudFailed": "雲端保存失敗，已儲存至本機",
  "editor.autosave.cloudUnavailable": "雲端保存暫未接入，已儲存至本地",
  "editor.autosave.failed": "自動儲存失敗，請複製內容後重試",
  "editor.autosave.enabled": "自動儲存已開啟",
  "identity.namePlaceholder": "你的名字",
  "identity.nameAria": "姓名或暱稱",
  "identity.identityPlaceholder": "一句話身份",
  "identity.identityAria": "一句話身份",
  "identity.tagsAria": "標籤",
  "identity.addTag": "添加標籤",
  "identity.removeTag": "刪除標籤 {tag}",
  "body.emptyInstruction": "寫下別人第一次認識你時最值得知道的幾件事。\n少寫一點，重要的才會被看見。30s，剛剛好。",
  "body.templatesLabel": "也可以從範本開始",
  "body.templatesAria": "正文身分模板",
  "body.templateExampleLabel": "模擬範例",
  "body.viewTemplateExample": "查看範例",
  "links.sectionAria": "連結",
  "links.documentTitle": "連結",
  "links.documentCopy": "社交主頁、預約和聯絡方式",
  "links.documentEmptyCopy": "新增社交主頁、預約或聯絡方式，之後可以隨時修改。",
  "links.add": "添加連結",
  "links.addType": "加入 {label}",
  "links.edit": "編輯 {label}",
  "links.addedAria": "已加入連結",
  "links.closePanel": "關閉連結編輯",
  "links.editTitle": "編輯連結",
  "links.addTitle": "添加連結",
  "links.chooseTypeAgain": "重新選擇連結類型",
  "links.calendarProvider": "預約平台",
  "links.displayName": "顯示名稱",
  "links.duplicate": "{label} 已經新增過。",
  "links.alreadyAdded": "{label} 已經新增過",
  "links.bookingAlreadyAdded": "預約已經增加過",
  "links.remove": "刪除",
  "links.category.social": "社群",
  "links.category.booking": "預約",
  "links.category.work": "作品 / 個人網站",
  "links.category.content": "內容",
  "links.category.contact": "聯繫",
  "links.category.other": "其他",
  "links.type.x": "X",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "小紅書",
  "links.type.wechat": "微信公眾號",
  "links.type.email": "Email",
  "links.type.calendar": "預約",
  "links.type.website": "網站",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "即刻",
  "links.type.other": "Other",
  "links.input.x": "X handle",
  "links.input.github": "GitHub handle",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "Instagram handle",
  "links.input.youtube": "YouTube handle",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "小紅書首頁 URL",
  "links.input.wechat": "公眾號碼 ID",
  "links.input.email": "信箱",
  "links.input.calendar": "預約路徑",
  "links.input.website": "網站 URL",
  "links.input.newsletter": "訂閱 URL",
  "links.input.tiktok": "TikTok handle",
  "links.input.threads": "Threads handle",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "Dribbble handle",
  "links.input.jike": "即時首頁 URL",
  "links.input.other": "連結 URL",
  "links.input.calendar.cal": "Cal.com 路徑",
  "links.input.calendar.calendly": "Calendly 路徑",
  "links.input.calendar.google": "Google Calendar 預約頁",
  "links.input.calendar.microsoft": "Microsoft Bookings 鏈接",
  "links.input.calendar.hubspot": "HubSpot Meetings 鏈接",
  "links.input.calendar.savvycal": "SavvyCal 路徑",
  "links.input.calendar.tidycal": "TidyCal 路徑",
  "links.input.calendar.zcal": "zcal 路徑",
  "links.hint.handle": "只填 handle，不需要 URL。",
  "links.hint.uid": "只填 UID，不需要主頁連結。",
  "links.hint.slug": "只填路徑，不需要完整 URL。",
  "links.hint.email": "會產生 mailto: 聯絡方式。",
  "links.hint.text": "公開頁點選後複製該內容。",
  "links.hint.url": "請輸入平台允許的 https:// 連結。",
  "links.hint.calendarSlug": "只填使用者名稱或預約路徑，不需要完整 URL。",
  "links.hint.calendarUrl": "請輸入該平台的完整預約頁連結。",
  "rich.toolbarAria": "正文格式工具列",
  "rich.heading": "章節標題",
  "rich.paragraph": "普通段落",
  "rich.bold": "加粗",
  "rich.boldFallback": "加粗文字",
  "rich.italic": "斜體",
  "rich.italicFallback": "斜體文字",
  "rich.code": "行內程式碼",
  "rich.comment": "切換註解",
  "rich.ul": "無序列表",
  "rich.ol": "有序列表",
  "rich.link": "連結",
  "rich.linkPrompt": "輸入 https:// 或 mailto: 鏈接",
  "rich.linkInvalid": "連結只支援 https:// 或 mailto:",
  "rich.linkFallback": "連結文字",
  "rich.aria": "30 秒介紹正文",
  "rich.more": "更多格式",
  "rich.quote": "引用",
  "rich.strikethrough": "刪除線",
  "rich.strikethroughFallback": "刪除線文字",
  "rich.codeBlock": "程式碼區塊",
  "rich.codeBlockFallback": "程式碼",
  "rich.taskList": "任務列表",
  "rich.table": "表格",
  "rich.tableSkeleton": "| 項目 | 說明 |\n| --- | --- |\n| 項目一 | 說明一 |\n| 項目二 | 說明二 |",
  "rich.indent": "增加縮排",
  "rich.outdent": "減少縮排",
  "rich.placeholder": "用 Markdown 寫下 30 秒內能讀完的介紹...",
  "feedback.aria": "寫作回饋",
  "feedback.timeTitle": "預計閱讀時間",
  "feedback.preview": "預覽",
  "feedback.previewMenu": "開啟預覽選單",
  "feedback.openAcceptancePreview": "開啟驗收預覽",
  "feedback.acceptancePreviewCopy": "在目前裝置查看公開頁效果",
  "feedback.noIssues": "沒有阻斷問題",
  "feedback.prePublish": "發布前檢查",
  "feedback.ready": "無阻斷項",
  "feedback.itemCount": "{count} 項",
  "feedback.valid": "內容滿足發布校驗。",
  "issue.action.displayName": "填寫姓名",
  "issue.action.oneLineIdentity": "填寫身份",
  "issue.action.tags": "添加標籤",
  "issue.action.body": "回到正文",
  "issue.action.handle": "選擇地址",
  "issue.action.links": "管理連結",
  "issue.action.view": "查看",
  "issue.short.displayName": "缺姓名",
  "issue.short.oneLineIdentity": "缺乏身份",
  "issue.short.tags": "缺標籤",
  "issue.short.handle": "缺地址",
  "issue.short.readingTime": "超過 60s",
  "issue.short.readingTimeLong": "超過 30s",
  "issue.short.readingTimeShort": "內容偏少",
  "issue.short.bodyPlaceholder": "正文佔位",
  "issue.short.bodyFormat": "正文格式",
  "issue.short.links": "連結有問題",
  "issue.short.linksEmpty": "可添加連結",
  "issue.short.pending": "待完善",
  "issue.summary.more": "{count} 項待完善",
  "publish.title.create": "確認發布",
  "publish.title.update": "確認發布修改",
  "publish.action.create": "發佈到 30s.to",
  "publish.action.update": "發布修改",
  "publish.closeAria": "關閉發布確認",
  "publish.address": "公開地址",
  "publish.unpublishedChanges": "有未發布修改",
  "publish.handleChanged": "公開網址將從 @{oldHandle} 改為 @{newHandle}。舊網址轉址 30 天；改名滿 180 天後可能分配給其他人，舊連結可能顯示對方的介紹。",
  "publish.readingTime": "閱讀時間",
  "publish.status": "狀態",
  "publish.ready": "可發布",
  "publish.todo": "{count} 項待完善",
  "publish.visibility": "公開方式",
  "publish.visibility.indexed": "允許搜尋引擎收錄",
  "publish.visibility.unlisted": "僅透過連結",
  "publish.visibility.indexedNote": "任何人都能查看，並可能出現在搜尋結果中。",
  "publish.visibility.unlistedNote": "任何取得連結的人都能查看；我們不會主動提交給搜尋引擎。",
  "publish.visibility.publicNote": "兩種方式都是公開存取，連結也可以被轉傳。若只想自己查看，請繼續保留為草稿。",
  "publish.publicContent": "發布後，姓名、身分、標籤、正文和連結將公開。作者註解不會顯示，但不應存放秘密資訊。",
  "publish.noop": "公開頁已是最新。修改內容或公開性後再發布。",
  "publish.valid": "內容滿足發布校驗。",
  "handleEdit.title": "修改公開地址",
  "handleEdit.label": "30s.to 位址",
  "handleEdit.help.changed": "儲存只修改草稿，發布後生效。舊網址轉址 30 天，改名滿 180 天後可能分配給其他人。",
  "handleEdit.help.saved": "儲存到草稿，發佈時會再次確認可用。",
  "handleEdit.note": "目前公開地址仍是 30s.to/@{handle}，新地址發布成功後才會生效。",
  "handleEdit.save": "儲存到草稿",
  "conflict.title": "選擇草稿版本",
  "conflict.copy": "這台設備和雲端都有未發佈內容。選擇後會作為接下來編輯的版本。",
  "conflict.useLocal": "使用本機草稿",
  "conflict.useLocalCopy": "保留目前頁面內容，並同步到雲端。",
  "conflict.useCloud": "使用雲端草稿",
  "conflict.untitled": "未命名",
  "conflict.cloudVersion": "雲端保存的版本",
  "conflict.modifiedAt": "最後修改 · {time}",
  "conflict.time.justNow": "剛剛",
  "conflict.time.minutesAgo": "{count} 分鐘前",
  "conflict.time.hoursAgo": "{count} 小時前",
  "conflict.time.daysAgo": "{count} 天前",
  "authModal.title": "登入 30s.to",
  "authModal.copy": "登入後草稿會同步到雲端，發布和管理也會更穩。",
  "login.page.eyebrow": "Account",
  "login.page.title": "登入 30s.to",
  "login.page.copy": "同步你的草稿、發佈公開頁，並管理邀請碼。",
  "login.invalidEmail": "請輸入有效郵箱。",
  "login.sendFailed": "驗證碼發送失敗。",
  "login.devCodeReady": "本機驗證碼已產生。",
  "login.codeSent": "驗證碼已發送，請檢查郵箱。",
  "login.networkSendFailed": "驗證碼發送失敗，請檢查網路。",
  "login.invalidCode": "請輸入 6 位元驗證碼。",
  "login.codeInvalid": "驗證碼不正確或已過期。",
  "login.failed": "登入失敗，請稍後重試。",
  "login.sendBusy": "發送中...",
  "login.resendCode": "重新發送驗證碼",
  "login.sendCode": "發送驗證碼",
  "login.localCode": "本機開發驗證碼：{code}",
  "login.code": "驗證碼",
  "login.codePlaceholder": "6 位數",
  "login.inviteHelp": "Public Beta 階段需要邀請碼。驗證成功後會啟動帳號。",
  "login.verifyBusy": "驗證中...",
  "login.verifyInvite": "驗證邀請碼並登入",
  "login.verify": "登入並繼續",
  "login.footnote": "無密碼登入。新用戶在郵箱驗證後使用邀請碼啟動。",
  "login.google": "使用 Google 繼續",
  "login.github": "使用 GitHub 繼續",
  "login.emailDivider": "或使用信箱",
  "login.oauthFailed": "社群登入未完成，請重新開始或改用信箱登入。",
  "login.linkTitle": "驗證帳號信箱",
  "login.linkPageCopy": "這個信箱已有 30s.to 帳號。驗證後才會建立關聯，不會自動合併。",
  "login.linkCopy": "驗證碼將會傳送到 {email}。郵箱不可在此修改。",
  "login.linkVerify": "驗證並關聯",
  "login.linkRequired": "偵測到已有帳號，請先驗證信箱。",
  "login.activateTitle": "啟動 30s.to",
  "login.activatePageCopy": "社交身分已驗證。邀請碼成功前不會建立永久帳號。",
  "login.activateCopy": "Public Beta 階段需要邀請碼。邀請碼只會在帳號建立成功時兌換。",
  "login.activationOpenCopy": "目前已開放註冊。繼續即可啟用帳號。",
  "login.activationClosedCopy": "目前暫不開放新帳號啟用，既有帳號仍可正常登入。",
  "login.activate": "激活並繼續",
  "login.inviteRequired": "郵箱已驗證，請使用邀請碼啟動。",
  "login.useEmailInstead": "改用信箱登入",
  "preview.emptyEyebrow": "Preview",
  "preview.emptyTitle": "沒有可預覽的介紹。",
  "preview.backToEdit": "回到編輯",
  "preview.edit": "編輯",
  "preview.localNoteAria": "本機預覽說明",
  "preview.localNote": "本機驗收",
  "preview.localTitle": "目前設備草稿預覽",
  "preview.themePicker": "主題切換",
  "preview.themeGroup": "選擇主題",
  "preview.themeFree": "基礎",
  "preview.themePro": "Pro",
  "preview.mobileAria": "行動端公開頁預覽",
  "preview.close": "關閉預覽",
  "preview.editorTitle": "預覽",
  "preview.publicTitle": "公開頁預覽",
  "preview.shareCardButton": "查看主題名片",
  "preview.shareCardDialogTitle": "主題名片預覽",
  "preview.shareCardTitle": "{theme} 主題名片",
  "preview.shareCardLogin": "登入後產生真實預覽",
  "preview.shareCardLoading": "正在產生主題名片…",
  "preview.shareCardError": "暫時無法產生名片預覽",
  "preview.shareCardNote": "主題專屬款會使用與公開頁一致的構圖語言；通用款可在管理頁選擇。",
  "public.copySuccess": "已複製 {label}",
  "public.copyFailed": "複製失敗，請手動複製。",
  "public.createMine": "創建我的介紹",
  "public.report": "檢舉這個頁面",
  "public.ownerAria": "個人管理入口",
  "public.owner.manage": "管理",
  "public.owner.edit": "編輯",
  "public.status.unavailable": "不可訪問",
  "public.status.notFound": "404",
  "public.status.moderated": "這個 30 秒介紹暫不可訪問。",
  "public.status.frozen": "這個公開地址暫不可進入。",
  "public.status.unpublished": "這個 30 秒介紹還沒發布。",
  "theme.footer": "Made with 30s.to",
  "theme.fallback.name": "Your Name",
  "theme.fallback.nameUpper": "YOUR NAME",
  "theme.fallback.nameNoir": "Name",
  "theme.fallback.nameIndex": "John Doe",
  "theme.fallback.identity": "What do you do?",
  "theme.fallback.identityUpper": "YOUR ONE LINE IDENTITY AND MISSION",
  "theme.fallback.identityIndex": "Unknown",
  "theme.fallback.identityNoir": "Identity",
  "theme.fallback.terminalName": "guest",
  "theme.fallback.terminalIntro": "還沒填一句話介紹",
  "theme.terminal.commandLabel": "終端命令",
  "theme.terminal.commandSubmit": "運行命令",
  "theme.terminal.outputLabel": "終端交互輸出",
  "theme.connect": "CONNECT",
  "theme.markdown.tableRegion": "正文表格，可水平捲動",
  "theme.markdown.task": "任務",
  "theme.tags": "TAGS",
  "theme.verified": "VERIFIED",
  "theme.name": "NAME",
  "theme.identityLabel": "IDENTITY",
  "theme.keywords": "KEYWORDS",
  "theme.scroll": "Scroll",
  "theme.pixel.previous": "上一螢幕",
  "theme.pixel.next": "下一頁",
  "theme.pixel.screen": "第 {current} 屏，共 {total} 屏",
  "theme.arcade.stage": "關卡 {current} / {total}",
  "theme.noise.reseed": "重排噪音",
  "theme.readingTime": "約 {seconds} 秒讀完",
  "theme.readingUnit": "秒讀完",
  "theme.letter.greeting": "你好，",
  "theme.letter.signoff": "祝好，",
  "theme.letter.postscript": "可以在這些地方找到我",
  "theme.letter.written": "寫於 {date}",
  "dashboard.loginTitle": "請先登入後管理你的介紹。",
  "dashboard.loginAction": "登入並管理",
  "dashboard.bannedTitle": "該帳號暫不可使用。",
  "dashboard.bannedCopy": "如果你認為這是誤判，請透過檢舉與申訴入口聯絡我們。",
  "connections.kicker": "帳戶",
  "connections.title": "登入方式",
  "connections.settingsKicker": "設定",
  "connections.settingsTitle": "帳戶與連線",
  "connections.settingsCopy": "管理登入身分和第三方 Agent 授權。",
  "connections.backToDashboard": "返回管理頁",
  "connections.emailCode": "郵箱驗證碼",
  "connections.alwaysAvailable": "始終可用",
  "connections.connect": "連接",
  "connections.disconnect": "解除 30s.to 關聯",
  "connections.notConnected": "未連接",
  "connections.noEmail": "未提供郵箱",
  "connections.emailVerified": "郵箱已驗證",
  "connections.connected": "已連接",
  "connections.unavailable": "暫未啟用",
  "connections.confirm": "確定解除 {provider} 與 30s.to 的關聯嗎？郵箱登入仍然保留。",
  "connections.removed": "已解除 30s.to 內的身份關聯。",
  "connections.failed": "登入方式更新失敗，請稍後再試。",
  "connections.help": "解除只刪除 30s.to 的身份映射，不會撤銷平台授權。管理平台授權：",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "Agent 連線",
  "agentConnections.copy": "安裝一個 Skill，讓你常用的 Agent 蒐集資訊、撰寫內容並安全更新 30s.to 草稿。",
  "agentConnections.addTitle": "連接新的 Agent",
  "agentConnections.addCopy": "查看連線網址和設定步驟",
  "agentConnections.examplesDisclosure": "查看使用範例",
  "settings.title": "設定",
  "settings.copy": "管理帳戶、安全性、外部連線和 30s.to 方案。",
  "settings.navAria": "設定分類",
  "settings.account.title": "帳戶",
  "settings.account.copy": "你的 30s.to 身分和個人介紹入口。",
  "settings.account.email": "帳戶郵箱",
  "settings.account.profile": "個人介紹",
  "settings.account.plan": "目前方案",
  "settings.account.manageProfile": "管理介紹",
  "settings.login.copy": "管理可用於登入 30s.to 的身分。",
  "settings.billing.copy": "查看目前方案、續訂狀態和帳單入口。",
  "settings.invites.copy": "管理 Public Beta 邀請額度和最近的邀請碼。",
  "agentConnections.endpoint": "連線網址",
  "agentConnections.copyAction": "複製",
  "agentConnections.copied": "已複製",
  "agentConnections.copyFailed": "複製失敗，請手動複製。",
  "agentConnections.endpointCopied": "連線網址已複製。",
  "agentConnections.stepsAria": "連接 Agent 的步驟",
  "agentConnections.step1": "在 Agent 的 MCP 或連接器設定中新增遠端服務。",
  "agentConnections.step2": "貼上連線網址，然後登入 30s.to 並確認授權。",
  "agentConnections.step3": "告訴 Agent 要修改什麼；完成後回到 30s.to 檢查草稿。",
  "agentConnections.examplesTitle": "可以這樣說",
  "agentConnections.exampleFirst": "讀取我的 30s.to 資料和格式規則，幫我完善第一次介紹。",
  "agentConnections.exampleSection": "保留原有語氣，只改寫「現在」這一節。",
  "agentConnections.exampleShorten": "將全文縮短到 30 秒內，不要直接發布。",
  "agentConnections.copyExample": "複製範例 {number}",
  "agentConnections.promptCopied": "範例指令已複製。",
  "agentConnections.boundary": "Agent 只能讀取及更新草稿，不能代你發布或停止公開。",
  "agentConnections.authorizedTitle": "已授權連線",
  "agentConnections.empty": "尚未授權任何 Agent 連線。",
  "agentConnections.disabled": "Agent 連線暫未啟用。",
  "agentConnections.scopeRead": "讀取草稿",
  "agentConnections.scopeWrite": "更新草稿",
  "agentConnections.connectedAt": "{date} 連線",
  "agentConnections.selfReported": "客戶端名稱由客戶端自行提供",
  "agentConnections.revoke": "撤銷",
  "agentConnections.confirm": "確定撤銷 {client} 的連線嗎？撤銷後，它將無法繼續存取你的 30s.to 草稿。",
  "agentConnections.confirmSkill": "確定撤銷 30s.to Skill 的連線嗎？撤銷後，使用這個 Skill 的本機 Agent 將同時登出 30s.to。",
  "agentConnections.revoked": "Agent 連線已撤銷。",
  "agentConnections.failed": "Agent 連線更新失敗，請稍後再試。",
  "agentConnections.manualTitle": "手動連接 Remote MCP",
  "agentConnections.manualCopy": "進階用法：為支援 Remote MCP 的客戶端個別授權",
  "skill.meta.title": "30s.to Skill — 讓 Agent 寫好你的 30 秒介紹",
  "skill.meta.description": "提供個人網站、專案或作品連結，讓 Agent 主動了解你，透過訪談寫好你的 30 秒介紹。",
  "skill.kicker": "30s.to Skill",
  "skill.title": "自我介紹，\n交給你的 Agent。",
  "skill.copy": "給它幾個連結，它會主動了解你，幫你寫好一份 30 秒自我介紹。",
  "skill.processTitle": "它怎麼幫你寫",
  "skill.process.clues.title": "提供連結",
  "skill.process.clues.copy": "公開個人網站、專案網站或作品集。",
  "skill.process.research.title": "充分調研，再訪談",
  "skill.process.research.copy": "深入研究你的個人網站、專案和作品，整理出重點，再透過訪談補足資料裡沒有的資訊。",
  "skill.process.profile.title": "寫好你的介紹",
  "skill.process.profile.copy": "一起調整內容和語氣，寫出你願意分享的介紹。",
  "skill.installTitle": "安裝到你的 Agent",
  "skill.installCopy": "複製指令，貼到你常用的 Agent 並送出。",
  "skill.promptLabel": "安裝指令",
  "skill.copyPrompt": "複製安裝指令",
  "skill.promptCopied": "安裝指令已複製。下一步：打開你常用的 Agent，貼上並傳送剛複製的指令。",
  "skill.copyFailed": "複製失敗，請手動複製下方的安裝指令。",
  "skill.startTitle": "如何開始",
  "skill.start.install": "安裝 30s.to Skill",
  "skill.start.chat": "開始聊",
  "skill.start.chatCopy": "安裝完成後，開啟新對話，告訴它：",
  "skill.start.prompt": "用 30s.to 幫我寫一份自我介紹。",
  "dashboard.kicker": "我的介紹",
  "dashboard.defaultTitle": "我的 30 秒介紹",
  "dashboard.primaryEdit": "繼續編輯",
  "dashboard.primaryCreate": "開始創建",
  "dashboard.unpublished": "尚未發布",
  "dashboard.unselected": "尚未選擇",
  "dashboard.confirmDiscard": "確定放棄未發布修改，恢復到目前公開版本嗎？",
  "dashboard.discardFailed": "放棄修改失敗。",
  "dashboard.discardConflict": "草稿已在其他位置更新，請重新整理頁面確認後再試。",
  "dashboard.discardNetworkFailed": "放棄修改失敗，請稍後重試。",
  "dashboard.discardDone": "已還原到目前公開版本。",
  "dashboard.statusAria": "目前狀態",
  "dashboard.versionAria": "版本關係",
  "dashboard.publicPage": "公開頁",
  "dashboard.indexingAllowed": "允許搜尋收錄",
  "dashboard.indexingBlocked": "僅透過連結",
  "dashboard.publicVersion": "已發布版本",
  "dashboard.invisible": "別人暫時看不到",
  "dashboard.draft": "草稿",
  "dashboard.currentDraft": "目前編輯版本",
  "dashboard.draftSynced": "與公開頁同步",
  "dashboard.editableVersionEmpty": "編輯版本 · 尚未創建",
  "dashboard.editableVersionDirty": "編輯版本 · 有修改未發布",
  "dashboard.editableVersionSynced": "編輯版本 · 與公開頁一致",
  "dashboard.editableVersionUnpublished": "編輯版本 · 尚未發布",
  "dashboard.betaActive": "已啟用",
  "dashboard.betaInactive": "未啟用",
  "dashboard.adminCanPublish": "管理員帳號可發布",
  "dashboard.betaAccessNote": "Public Beta 發布權限",
  "dashboard.visibility": "公開範圍",
  "dashboard.chooseOnPublish": "發布確認時選擇",
  "dashboard.snapshot": "快照",
  "dashboard.snapshotAfterPublish": "發布後產生公開頁快照",
  "dashboard.publishDetailsAria": "發布詳情",
  "dashboard.actionsAria": "管理操作",
  "dashboard.nextAction": "下一步",
  "dashboard.openPublicPage": "打開公開頁",
  "dashboard.changeVisibility": "修改公開方式",
  "dashboard.unpublish": "停止公開",
  "dashboard.unpublishTitle": "停止公開？",
  "dashboard.unpublishDescription": "公開頁將立即停止存取；草稿和公開地址會保留，之後可以重新發布。",
  "dashboard.unpublishWarning": "搜尋引擎或其他人已儲存的副本可能不會立即消失。",
  "dashboard.unpublishConfirm": "停止公開",
  "dashboard.unpublishBusy": "正在停止...",
  "dashboard.unpublishSuccess": "公開頁已停止存取，草稿和公開地址已保留。",
  "dashboard.unpublishFailed": "無法停止公開，請稍後再試。",
  "dashboard.discardBusy": "恢復中...",
  "dashboard.discard": "放棄修改",
  "dashboard.metricsAria": "輕量數據",
  "dashboard.views": "訪問",
  "dashboard.clicks": "點選",
  "dashboard.readingTime": "閱讀時間",
  "dashboard.theme": "主題",
  "dashboard.noTheme": "尚未選擇",
  "dashboard.visibility.indexed": "允許搜尋引擎收錄",
  "dashboard.visibility.unlisted": "僅透過連結",
  "dashboard.visibility.indexedNote": "可能出現在搜尋結果中",
  "dashboard.visibility.unlistedNote": "取得直接連結的人仍可查看",
  "dashboard.snapshot.ready": "快取正常",
  "dashboard.snapshot.failed": "D1 fallback",
  "dashboard.snapshot.none": "未生成",
  "dashboard.snapshot.readyNote": "公開頁快照已寫入 KV",
  "dashboard.snapshot.failedNote": "公開頁仍透過 D1 fallback 可存取",
  "dashboard.snapshot.noneNote": "目前已發布版本沒有可用快照",
  "invite.title": "邀請朋友加入 Public Beta",
  "invite.remaining": "本月剩餘 {remaining} / {quota}。",
  "invite.generateFailed": "生成失敗。",
  "invite.generated": "已生成 {count} 個邀請碼，只會顯示這次。",
  "invite.quotaUsed": "本月邀請額度已用完。",
  "invite.generating": "生成中...",
  "invite.generate": "一次生成剩餘 {count} 個",
  "invite.batchTitle": "本次生成的 {count} 個邀請碼",
  "invite.copyAll": "複製全部邀請碼",
  "invite.copiedAll": "已複製全部邀請碼",
  "invite.copyMessage": "複製分享文案",
  "invite.messageCopied": "已複製分享文案",
  "invite.share": "直接分享",
  "invite.shared": "已開啟分享面板。",
  "invite.shareFallback": "目前裝置不支援直接分享，分享文案已複製。",
  "invite.shareFailed": "暫時無法分享，請複製分享文案。",
  "invite.shareMessage": "我正在用 30s.to 製作一份 30 秒個人介紹，也邀請你來試試。\n\n邀請碼：\n{codes}\n\n開啟 {url} 開始建立。",
  "invite.recentAria": "邀請碼使用狀態",
  "invite.statusTitle": "使用狀態",
  "invite.statusSummary": "{active} 個可用 · {redeemed} 個已使用 · {expired} 個已過期 · {revoked} 個已撤銷",
  "invite.status.revoked": "已撤銷",
  "invite.status.redeemed": "已使用",
  "invite.status.expired": "已過期",
  "invite.status.active": "可用",
  "invite.copy": "複製",
  "invite.copied": "已複製",
  "invite.showOnce": "只顯示這次",
  "invite.expiryUnknown": "有效期限未知",
  "invite.expiresAt": "有效期限至 {date}",
  "management.handlePending.title": "地址變更待發布",
  "management.handlePending.description": "目前公開地址仍是 {publishedAddress}，發布後新地址 {draftAddress} 生效。",
  "management.handlePending.next": "發布修改後，新地址 {draftAddress} 才會成為公開地址。",
  "management.dirty.title": "有未發布修改",
  "management.dirty.description": "草稿還沒有發佈到公開頁。",
  "management.dirty.next": "發布修改後，公開頁會同步目前草稿。",
  "management.published.title": "已發布",
  "management.published.description": "公開頁已是最新。",
  "management.published.next": "公開頁已同步；需調整內容時繼續編輯即可。",
  "management.unpublished.title": "未發布",
  "management.unpublished.description": "這份介紹還只保存在草稿裡，別人還看不到。",
  "management.unpublished.next": "發布後，別人才能透過公開地址存取這份介紹。",
  "management.empty.title": "還沒介紹",
  "management.empty.description": "先選擇地址並寫一段 30 秒介紹。",
  "management.empty.next": "先建立草稿；發布前檢查會在編輯頁處理。",
  "management.publish.create": "發布介紹",
  "management.publish.update": "發布修改",
  "abuse.kicker": "Trust & Safety",
  "abuse.title": "檢舉頁面",
  "abuse.copy": "檢舉只用於安全審核，不會公開你的身分。",
  "abuse.missingHandle": "缺少檢舉對象。",
  "abuse.done": "已收到檢舉，我們會盡快處理。",
  "abuse.failed": "提交失敗，請稍後重試。",
  "abuse.reason.spam": "垃圾內容",
  "abuse.reason.impersonation": "冒充他人",
  "abuse.reason.abuse": "騷擾或仇恨",
  "abuse.reason.illegal": "違法內容",
  "abuse.reason.other": "其他問題",
  "abuse.submitBusy": "提交中…",
  "abuse.submit": "提交舉報",
  "terms.title": "服務條款",
  "privacy.title": "隱私權說明",
  "validation.handle.required": "請輸入 handle。",
  "validation.handle.invalid": "handle 只能使用 4-24 位小寫英文字母。",
  "validation.handle.reserved": "這個公開地址不可用，換一個試試。",
  "validation.handle.unavailable": "這個公開地址不可用，換一個試試。",
  "validation.handle.frozen": "這個公開地址不可用，換一個試試。",
  "validation.handle.protected": "這個公開地址不可用，換一個試試。",
  "validation.handle.checkFailed": "暫時無法確認地址狀態。",
  "validation.handle.changeLimit": "30 天內只能更改一次公開地址。",
  "validation.displayName.required": "姓名/暱稱必填。",
  "validation.identity.required": "一句話身份必填。",
  "validation.tags.range": "標籤需要填寫 1-5 個。",
  "validation.links.limit": "獨立連結最多 {limit} 個。",
  "validation.links.empty": "還沒有添加連結；可以補充社交主頁、預約或聯絡方式。",
  "validation.input.tooLong": "輸入內容最多 {limit} 個字元。",
  "validation.body.placeholder": "內文仍包含{detail}，請替換成真實內容或刪除。",
  "validation.body.oldTemplate": "舊正文模板",
  "validation.body.readingTime": "目前預計 {seconds} 秒，請精簡到 {maximum} 秒內。",
  "validation.body.readingTimeLong": "目前預計 {seconds} 秒，超過建議的 {recommended} 秒，但仍可發布。",
  "validation.body.readingTimeShort": "目前預計 {seconds} 秒，內容偏少；建議補充到至少 {minimum} 秒。",
  "validation.markdown.h1": "不支援 # 頁面級標題",
  "validation.markdown.deepHeading": "不支援 ### 或更深層的標題",
  "validation.markdown.image": "不支援圖片文法",
  "validation.markdown.codeBlock": "不支援程式碼區塊",
  "validation.markdown.taskList": "不支援任務列表",
  "validation.markdown.table": "不支援表格",
  "validation.markdown.footnote": "不支援腳註",
  "validation.markdown.html": "不支援 HTML 或嵌入",
  "validation.markdown.commentUnclosed": "正文註解缺少結束標記 -->",
  "validation.markdown.commentStrayClose": "正文註解缺少開始標記 <!--",
  "validation.markdown.commentNested": "正文註解不支援巢狀 <!-- -->",
  "validation.markdown.nestedHeading": "章節標題只能位於文件根層級",
  "validation.markdown.setextHeading": "不支援 Setext 標題",
  "validation.markdown.headingInline": "章節標題只能包含純文字",
  "validation.markdown.frontmatter": "不支援 frontmatter",
  "validation.markdown.indentedCode": "不支援縮排程式碼區塊，請使用圍欄程式碼區塊",
  "validation.markdown.codeFenceUnclosed": "程式碼圍欄缺少結束標記",
  "validation.markdown.codeLanguage": "程式碼語言標籤只允許 1–32 個字母、數字、_、+ 或 -",
  "validation.markdown.listDepth": "列表最多支援三級巢狀",
  "validation.markdown.tableSize": "表格最多支援 6 欄、20 列",
  "validation.markdown.linkProtocol": "正文連結只支援 HTTPS 和電子郵件",
  "validation.link.unsupportedType": "暫不支援此連結類型，請選擇網站、平台或預約連結。",
  "validation.link.labelRequired": "連結名稱不能為空。",
  "validation.link.providerRequired": "請選擇預約平台。",
  "validation.link.valueRequired": "{label} 不能為空。",
  "validation.link.httpsOnly": "連結只支援 https://。",
  "validation.link.invalid": "請輸入有效連結。",
  "validation.link.validEmail": "請輸入有效郵箱。",
  "validation.link.validGithub": "請輸入有效的 GitHub handle。",
  "validation.link.validBilibili": "請輸入有效的 Bilibili UID。",
  "validation.link.validXiaohongshu": "請輸入有效的小紅書主頁連結。",
  "validation.link.validGoogleCalendar": "請輸入有效的 Google Calendar 預約連結。",
  "validation.link.validMicrosoftBookings": "請輸入有效的 Microsoft Bookings 連結。",
  "validation.link.validHubSpot": "請輸入有效的 HubSpot Meetings 連結。",
  "validation.account.banned": "該帳號暫不可發布。",
  "validation.theme.proRequired": "這個主題需要 30s Pro，升級後即可發布。",
  "validation.account.login": "請先登入。",
  "validation.account.invite": "請先使用邀請碼啟動帳號。",
  "validation.publish.failed": "發布失敗，請稍後重試。",
  "validation.turnstile.required": "請完成人機校驗。",
  "validation.report.missing": "缺少檢舉對象。",
  "validation.report.reason": "請選擇檢舉原因。",
  "validation.report.notReportable": "這個頁面目前不可檢舉。",
  "common.listSeparator": "、",
  "dashboard.section.status": "狀態",
  "dashboard.section.performance": "表現",
  "dashboard.fullAnalytics": "查看完整分析",
  "dashboard.shareCard": "分享卡片",
  "dashboard.timestamp.notPublished": "尚未發布",
  "dashboard.timestamp.notEdited": "尚未編輯",
  "dashboard.timestamp.published": "發佈於 {date} UTC",
  "dashboard.timestamp.edited": "編輯於 {date} UTC",
  "upgrade.publishTheme": "發布 {theme}",
  "upgrade.copy": "你的選擇已經儲存，也可以繼續完整預覽。升級後無需重新編輯，回來即可發布。",
  "upgrade.benefit.themes": "發布全部高級主題",
  "upgrade.benefit.analytics": "查看閱讀時間與完讀分析",
  "upgrade.benefit.cards": "主題名片同步社交 OG",
  "upgrade.seePro": "看 30s Pro",
  "upgrade.keepEditing": "繼續編輯",
  "pro.meta.title": "30s Pro — 表達更像自己",
  "pro.meta.description": "進階主題、閱讀品質分析與主題分享名片，讓你的 30 秒介紹更像自己。",
  "pro.title": "表達更像自己。",
  "pro.intro": "內容仍然只有 30 秒。 Pro 給你更多表達方式、更清楚的回饋，以及隨手就能分享的素材。",
  "pro.priceAction": "查看 Founding Price",
  "pro.summaryAria": "Pro 權益摘要",
  "pro.summaryThemes": "款高級主題",
  "pro.summaryAnalytics": "天分析",
  "pro.summaryShare": "與名片同步",
  "pro.benefitsKicker": "Pro 工具箱",
  "pro.benefitsTitle": "從表達，到被看見。",
  "pro.benefit.themes.title": "高級主題",
  "pro.benefit.themes.body": "Terminal 領銜的 8 款主題。 Free 可以完整預覽，Pro 才能發布。",
  "pro.benefit.analytics.title": "閱讀品質",
  "pro.benefit.analytics.body": "不只看訪問量：查看有效閱讀時間、完讀率與進度分佈，再結合 30 / 90 / 365 天趨勢與連結 CTR。",
  "pro.benefit.share.title": "分享也像你",
  "pro.benefit.share.body": "Free 只有名字與連結的基礎卡；Pro 提供兩款通用名片與每個主題的專屬名片。選定即同步為 OG，QR 融入卡面，可直接分享與下載。",
  "pro.benefit.attribution.title": "只留下你",
  "pro.benefit.attribution.body": "隱藏主題內部的 30s.to 署名；舉報與語言等必要公共功能仍然保留。",
  "pro.pricingTitle": "越早加入，越簡單。",
  "pro.pricingBody": "連續訂閱期間保留 Founding Price。取消生效後再次加入，將使用屆時價格。",
  "pro.terminalAria": "Terminal Pro 主題示意",
  "pro.checkout.continuous": "持續訂閱，即可保留",
  "pro.checkout.intervalAria": "訂閱週期",
  "pro.checkout.monthly": "月付",
  "pro.checkout.yearly": "年付",
  "pro.checkout.save": "省 $16",
  "pro.checkout.periodYear": "年",
  "pro.checkout.periodMonth": "月",
  "pro.checkout.annualNote": "相當於每月 ${price}，比月付節省 44%。",
  "pro.checkout.monthlyNote": "靈活按月訂閱，隨時在周期末取消。",
  "pro.checkout.includeThemes": "全部高級主題",
  "pro.checkout.includeAnalytics": "閱讀品質與 365 天分析",
  "pro.checkout.includeCards": "主題名片、QR 與 OG",
  "pro.checkout.includeAttribution": "隱藏主題內署名",
  "pro.checkout.manage": "管理我的 Pro",
  "pro.checkout.comingSoon": "結帳即將開放",
  "pro.checkout.signIn": "登入後升級",
  "pro.checkout.inviteRequired": "需要 Beta 邀請資格",
  "pro.checkout.opening": "正在開啟安全結帳…",
  "pro.checkout.upgrade": "升級到 30s Pro",
  "pro.checkout.footnote": "由 Creem 安全結帳。適用稅金將在付款前顯示；無試用，自動續費。",
  "pro.checkout.unavailable": "暫時無法開啟結帳，請稍後重試。",
  "pro.checkout.networkError": "網路連線失敗，請稍後重試。",
  "billing.panelAria": "Pro 與帳單",
  "billing.plan": "方案",
  "billing.status.canceling": "已安排取消",
  "billing.status.pastDue": "付款逾期",
  "billing.status.active": "使用中",
  "billing.status.free": "免費",
  "billing.yearly": "年付",
  "billing.monthly": "月付",
  "billing.basicPlan": "基礎方案",
  "billing.ends": "結束 {date}",
  "billing.renews": "續費 {date}",
  "billing.graceEnds": "寬限期至：{date}",
  "billing.anomaly": "帳單狀態需要人工檢查，請聯絡 support@30s.to。",
  "billing.opening": "正在開啟帳單管理",
  "billing.manage": "管理帳單",
  "billing.upgrade": "升級 Pro",
  "billing.openingHistory": "正在開啟帳單紀錄…",
  "billing.viewHistory": "檢視歷史帳單",
  "billing.portalUnavailable": "暫時無法開啟訂閱管理。",
  "billing.networkError": "網路連線失敗，請稍後重試。",
  "billingReturn.kicker": "30s Pro · 付款確認",
  "billingReturn.activeTitle": "Pro 已開通",
  "billingReturn.failedTitle": "還沒有確認付款",
  "billingReturn.waitingTitle": "正在確認付款",
  "billingReturn.failedCopy": "付款狀態可能仍在同步。你可以返回管理頁稍後查看；我們不會僅憑回跳頁面開通權益。",
  "billingReturn.waitingCopy": "正在和支付服務核對訂閱狀態，請不要關閉頁面。",
  "billingReturn.back": "返回管理頁",
  "analytics.kicker": "30s Pro · 分析",
  "analytics.nav": "數據",
  "analytics.title": "從看見，到讀完。",
  "analytics.copy": "從訪問到完讀與互動，而不是追蹤個人。所有日期與去重口徑均使用 UTC。",
  "analytics.rangeAria": "時間範圍",
  "analytics.days": "{count} 天",
  "analytics.uniqueVisitors": "獨立訪客",
  "analytics.rangeTotal": "{count} 天累計",
  "analytics.averageReading": "平均有效閱讀",
  "analytics.activeReadingNote": "可見且聚焦的閱讀時間",
  "analytics.completionRate": "完讀率",
  "analytics.completedVisitors": "{count} 位訪客完成閱讀",
  "analytics.overallCtr": "總體 CTR",
  "analytics.engagedVisitors": "{count} 位互動訪客",
  "analytics.trafficTrend": "訪問趨勢",
  "analytics.dailyTrendAria": "每日獨立訪客趨勢",
  "analytics.readingCompletion": "完讀分佈",
  "analytics.dailyMaximum": "訪客 / 當日最高進度",
  "analytics.visitorCount": "{count} 人",
  "analytics.topLinks": "熱門連結",
  "analytics.uniqueClickers": "獨立點擊者",
  "analytics.linkTrendAria": "{label} 每日趨勢",
  "analytics.noInteractions": "還沒有連結互動。",
  "analytics.audienceOverview": "訪客概覽",
  "analytics.pageLevel": "頁面級",
  "analytics.referrers": "來源",
  "analytics.devices": "裝置",
  "analytics.countries": "國家",
  "analytics.noData": "暫無資料",
  "analytics.durationSeconds": "{seconds} 秒",
  "analytics.durationMinutes": "{minutes} 分 {seconds} 秒",
  "share.card": "分享卡片",
  "share.variant.classic": "經典",
  "share.variant.classicNote": "留白",
  "share.variant.contact": "索引",
  "share.variant.contactNote": "秩序",
  "share.variant.theme": "{theme} 專屬",
  "share.variant.themeNote": "主題",
  "share.variant.universal": "一般",
  "share.saveFailed": "保存失敗",
  "share.styleUpdated": "樣式已更新",
  "share.networkError": "網路連線失敗",
  "share.linkCopied": "連結已複製",
  "share.copyFailed": "複製失敗",
  "share.text": "我的 30 秒介紹",
  "share.failed": "分享失敗",
  "share.published": "已發布",
  "share.draft": "草稿",
  "share.style": "樣式",
  "share.alt": "{name} 的分享卡",
  "share.publishFirst": "發布後可分享",
  "share.action": "分享",
  "share.download": "下載",
  "share.openPublicPage": "打開公開頁",
  "share.chooseStyle": "選擇卡片樣式",
  "share.close": "關閉",
  "share.cardStyle": "卡片樣式",
  "share.chooseOne": "選擇一個樣式",
  "share.chooseStyleAria": "選擇分享卡樣式",
  "share.saving": "儲存中",
  "validation.body.placeholderDetail.legacyTemplate": "舊正文模板",
  "validation.body.placeholderDetail.ellipsis": "`...` 佔位符",
  "validation.body.placeholderDetail.sampleLink": "範例連結 `https://example.com`",
  "validation.body.placeholderDetail.projectName": "「專案名」佔位",
  "validation.body.placeholderDetail.instruction": "模板說明「一句話說明它解決什麼問題」",
  "analytics.gate.signInTitle": "登入後查看分析",
  "analytics.gate.signInCopy": "你的瀏覽與互動資料會安全地保留在管理頁。",
  "analytics.gate.signInAction": "登入",
  "analytics.gate.proTitle": "了解你的介紹是否被讀完。",
  "analytics.gate.proCopy": "查看有效閱讀時間、完讀率、進度分布、30／90／365 天趨勢與連結 CTR。",
  "analytics.gate.proAction": "查看 30s Pro",
  "analytics.gate.emptyTitle": "發布後，資料從這裡開始。",
  "analytics.gate.emptyCopy": "先完成你的 30 秒介紹；發布後即可看到瀏覽與互動趨勢。",
  "analytics.gate.emptyAction": "開始建立",
  "analytics.gate.privacyNote": "UTC 每日彙總 · 匿名去重 · 不儲存原始 IP",
  "handleEdit.previous": "受保護的舊網址",
  "handleEdit.deadlines": "轉址至 {redirectDate}；保護至 {releaseDate}。",
  "handleEdit.usePrevious": "使用此網址",
  "handleEdit.reclaimAvailable": "你可以領回這個舊網址。",
  "publish.handleReclaimed": "領回也算更換網址；目前網址將開始新的 30 天轉址及 180 天保護期。"
}
